module.exports = __webpack_public_path__ + "static/media/[붙임1] 기후과학클래스 모집 포스터.68447d1e.jpg";